// @flow
// Used for IBs that use the <AppearancePicker /> component to dynamically inject values

export type Appearance = {
  theme: 'stripe' | 'night' | 'flat',
  primaryColor: string,
  backgroundColor: string,
  textColor: string,
};

export const DEFAULT_APPEARANCE_COLORS = {
  stripe: {
    primaryColor: '#0570de',
    backgroundColor: '#ffffff',
    textColor: '#30313d',
  },
  night: {
    primaryColor: '#85d996',
    backgroundColor: '#30313d',
    textColor: '#fff',
  },
  flat: {
    primaryColor: '#007aff',
    backgroundColor: '#f5f5f5',
    textColor: '#30313d',
  },
};

export const formatAppearanceObject = (
  appearance: Appearance,
): Array<string> => {
  const appearanceLines = [];
  appearanceLines.push(`    theme: '${appearance.theme}',`);
  if (
    DEFAULT_APPEARANCE_COLORS[appearance.theme].primaryColor !==
      appearance.primaryColor ||
    DEFAULT_APPEARANCE_COLORS[appearance.theme].backgroundColor !==
      appearance.backgroundColor ||
    DEFAULT_APPEARANCE_COLORS[appearance.theme].textColor !==
      appearance.textColor
  ) {
    appearanceLines.push('    variables: {');
    if (
      DEFAULT_APPEARANCE_COLORS[appearance.theme].primaryColor !==
      appearance.primaryColor
    ) {
      appearanceLines.push(`      colorPrimary: '${appearance.primaryColor}',`);
    }
    if (
      DEFAULT_APPEARANCE_COLORS[appearance.theme].backgroundColor !==
      appearance.backgroundColor
    ) {
      appearanceLines.push(
        `      colorBackground: '${appearance.backgroundColor}',`,
      );
    }
    if (
      DEFAULT_APPEARANCE_COLORS[appearance.theme].textColor !==
      appearance.textColor
    ) {
      appearanceLines.push(`      colorText: '${appearance.textColor}',`);
    }
    appearanceLines.push('    },');
  }

  return appearanceLines;
};
